// import { logDOM } from '@testing-library/react';
// import axios from 'axios';

// const instance = axios.create({

//     baseURL: 'https://localhost:44313/api'});

   
    
//     if(window.innerWidth<700)
//         instance.defaults.headers.common['DeviceCode'] =  "MV";
//     else
//         instance.defaults.headers.common['DeviceCode'] =  "W";
   

    
// export default instance;


import axios from 'axios';

//"India": "https://localhost:44313/api",

const API_BASE_URLS = {
  "IN": "https://b2capiuat.alhindit.com/api",
  "AE": "https://apiaealhindb2c.alhindit.com/api",
  "QA": "https://apiqaalhindb2c.alhindit.com/api",
  "OM": "https://apiomalhindb2c.alhindit.com/api",
  "SA": "https://localhost:44313/api",
  "BH": "https://apibaalhindb2c.alhindit.com/api",
  "KW": "https://apikwdalhindb2c.alhindit.com/api"
};

// const API_BASE_URLS = {
//   "IN": "https://b2capi.alhind.com/api",
//   "AE": "https://b2capiae.alhind.com/api",
//   "QA": "https://apiqaalhindb2c.alhind1.com/api",
//   "OM": "https://apiomalhindb2c.alhind1.com/api",
//   "SA": "https://b2capisa.alhind.com/api",
//   "BH": "https://apibaalhindb2c.alhind1.com/api",
//   "KW": "https://apikwalhindb2c.alhind1.com/api"
// };

const getBaseURL = () => {
  const country = localStorage.getItem("selectedCountryCode") || "IN";
    console.log(country);
  return API_BASE_URLS[country] || API_BASE_URLS["India"];
};

const AxiosConfig = () => {
  const instance = axios.create({
    baseURL: getBaseURL()
  });

  if (window.innerWidth < 700)
    instance.defaults.headers.common['DeviceCode'] = "MV";
  else
    instance.defaults.headers.common['DeviceCode'] = "W";



  return instance;
};

export default AxiosConfig;